import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['validityPeriodInput', 'expirationThresholdInput', 'notificationThresholdInput', 'selectedProgramsSection', 'selectedProgramsTable'];

  static values = {
    selectedPrograms: Array,
    thresholdDisabledMessage: String
  };

  connect() {
    const initialSelectedPrograms = this.hasSelectedProgramsValue ? this.selectedProgramsValue : [];
    this.selectedPrograms = new Set(initialSelectedPrograms);

    this._boundThresholdFieldsHandler = this._updateThresholdFieldsOnInput.bind(this);
    this.validityPeriodInputTarget.addEventListener('input', this._boundThresholdFieldsHandler);
    this.validityPeriodInputTarget.addEventListener('change', this._boundThresholdFieldsHandler);

    this._boundThresholdErrorsHandler = this._toggleErrorsOnThresholdFields.bind(this);
    this.expirationThresholdInputTarget.addEventListener('input', this._boundThresholdErrorsHandler);
    this.notificationThresholdInputTarget.addEventListener('input', this._boundThresholdErrorsHandler);
    this.expirationThresholdInputTarget.addEventListener('change', this._boundThresholdErrorsHandler);
    this.notificationThresholdInputTarget.addEventListener('change', this._boundThresholdErrorsHandler);
  }

  toggleProgram(event) {
    const target = event.currentTarget;
    const programName = target.querySelector('.js-menu-option-text').innerHTML.trim();

    if (target.classList.contains('js-selected')) {
      this.selectedPrograms.add(programName);
      this._addProgramToTable();
    } else {
      this.selectedPrograms.delete(programName);
      this._removeProgramFromTable();
    }
  }

  _addProgramToTable() {
    this._renderPrograms();
  
    if (this.selectedProgramsSectionTarget.classList.contains('hidden')) {
      this.selectedProgramsSectionTarget.classList.remove('hidden');
    }
  }

  _removeProgramFromTable() {
    if (this.selectedPrograms.size === 0) {
      this.selectedProgramsSectionTarget.classList.add('hidden');
      return;
    }

    this._renderPrograms();
  }

  _renderPrograms() {
    const rowsSection = this.selectedProgramsTableTarget.querySelector('.rows-section');
    const templateRow = rowsSection.querySelector('.table-body-row').cloneNode(true);

    rowsSection.innerHTML = '';

    [...this.selectedPrograms].sort().forEach(programName => {
      const newRow = templateRow.cloneNode(true);
      newRow.querySelector('.table-body-cell').textContent = programName;
      rowsSection.append(newRow);
    });
  }

  _updateThresholdFieldsOnInput() {
    this._toggleThresholdFields()
    this._boundThresholdErrorsHandler();
  }

  _toggleThresholdFields() {
    const validityValue = parseInt(this.validityPeriodInputTarget.value, 10);
    const enabled = !isNaN(validityValue) && validityValue > 0;

    [this.expirationThresholdInputTarget, this.notificationThresholdInputTarget].forEach(input => {
      if (enabled) {
        input.dispatchEvent(new CustomEvent('promote:number-picker-enable'));
        input.dispatchEvent(new CustomEvent('promote:number-picker-update-hint', { detail: { value: '' } }));
      } else {
        input.dispatchEvent(new CustomEvent('change', { detail: { value: '' } }));
        input.dispatchEvent(new CustomEvent('promote:number-picker-disable'));
        input.dispatchEvent(
          new CustomEvent('promote:number-picker-update-hint',
            { detail: { value: this.thresholdDisabledMessageValue } })
        );
      }
    });
  }

  _toggleErrorsOnThresholdFields() {
    const validityValue = parseInt(this.validityPeriodInputTarget.value, 10);
    const enabled = !isNaN(validityValue) && validityValue > 0;

    [this.expirationThresholdInputTarget, this.notificationThresholdInputTarget].forEach(input => {
      const thresholdValue = parseInt(input.value, 10);
      const hasError = enabled && !isNaN(thresholdValue) && thresholdValue > validityValue;
      input.closest('.js-input-form').classList.toggle('error', hasError);
    });
  }

}
